module.exports = __webpack_public_path__ + "img/coverage-6.731ed738.svg";